module.exports = __webpack_public_path__ + "static/media/gl.d56c1f2f.svg";